const MuiPickersCalendarHeader = {
    styleOverrides: {
        root: ({ theme })=>({
                borderBottom: `1px solid ${theme.palette.divider}`,
                marginBottom: 0,
                paddingBottom: '16px',
                position: 'relative',
                ['.MuiPickersArrowSwitcher-root']: {
                    display: 'flex',
                    position: 'absolute',
                    left: '8px',
                    right: '8px',
                    justifyContent: 'space-between'
                }
            }),
        labelContainer: {
            marginLeft: 'auto'
        },
        switchViewButton: {
            display: 'none'
        }
    }
};
export { MuiPickersCalendarHeader };

//# sourceMappingURL=pickers-calendar-header-overrides.js.map